"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var heroWave_svg_1 = __importDefault(require("../assets/heroWave.svg"));
var fancy_underline_svg_1 = __importDefault(require("../assets/fancy-underline.svg"));
var man_on_computer_png_1 = __importDefault(require("../assets/man-on-computer.png"));
function Hero(_a) {
    var yPosition = _a.yPosition, width = _a.width;
    var style = {
        background: "url(".concat(man_on_computer_png_1.default, "), url(").concat(heroWave_svg_1.default, ")"),
        backgroundRepeat: 'no-repeat',
        backgroundSize: width < 750 ? '90%, 110%' : 'auto, contain',
        backgroundPosition: width < 1200 ? '100% 90%, 100% 100%' : '80% 50%, 100% 100%'
    };
    return (react_1.default.createElement("section", { className: "hero", id: "hero", style: style }, yPosition < 800 &&
        react_1.default.createElement("div", { className: "hero--title-section" },
            react_1.default.createElement("h3", { className: "hero--introduction" }, "Hello, my name is"),
            react_1.default.createElement("h1", { className: "hero--name" }, "SKYLAR"),
            react_1.default.createElement("img", { src: fancy_underline_svg_1.default, className: "hero--underline", alt: 'fancy underline for name' }),
            react_1.default.createElement("p", { className: "hero--description" }, "Fullstack Software Engineer"))));
}
exports.default = Hero;
